import { apiFetch } from "./client";
import type { SyncRunNowResponse, SyncSetEnabledResponse, SyncStatusResponse } from "./types";

/** Admin Sync Center (Sync Orchestration §11). Status is read by admin-type or
 *  super_admin; mutations (enable/disable, force-unlock) are super_admin-only and
 *  enforced server-side — the client only gates UI affordances. */

export function fetchSyncStatus(signal?: AbortSignal): Promise<SyncStatusResponse> {
  return apiFetch<SyncStatusResponse>("/Custom/sync/status", { signal });
}

/** Set the admin override for a job. Only 'inherit' | 'disabled' — a deploy-gated
 *  job can never be forced ON (§2 / clarification 2). */
export function setJobEnabled(
  jobId: string,
  override: "inherit" | "disabled",
): Promise<SyncSetEnabledResponse> {
  return apiFetch<SyncSetEnabledResponse>(
    `/Custom/sync/jobs/${encodeURIComponent(jobId)}/enabled`,
    { method: "PUT", body: { override } },
  );
}

/** Queue a manual dry-run (§9). Stage 5: dry-run only — the orchestrator tick
 *  consumes the request through the full lock/gate/audit path. super_admin only. */
export function runNowJob(
  jobId: string,
  mode: string,
  reason: string,
): Promise<SyncRunNowResponse> {
  return apiFetch<SyncRunNowResponse>(
    `/Custom/sync/jobs/${encodeURIComponent(jobId)}/run-now`,
    { method: "POST", body: { mode, reason } },
  );
}

/** Force-clear the global writer lock (reuses the existing SyncLock endpoint).
 *  super_admin + reason, audited server-side. */
export function forceUnlock(
  key: string,
  reason: string,
): Promise<{ forced: boolean; lockKey: string }> {
  return apiFetch<{ forced: boolean; lockKey: string }>(
    "/Custom/sync/lock/force-unlock",
    { method: "POST", body: { key, reason } },
  );
}
